
import whySymMachine from "../../assets/special-offer/why-sym-machine.webp";

export const offerData = {
  phoneDisplay: "02 6674 8231",
  phoneHref: "tel:0266748231",

  heroTitle: "One call could save you up to $15,000 on your first SYM machine.",

  disclaimer:
    "Savings up to $15,000 apply to your first SYM Machinery purchase of a TerrainX35 or Titan35. Limited time only. Conditions apply; ask a SYM team member for details.",

  machines: [
    {
      id: "terrainx35",
      name: "TerrainX35",
      image: whySymMachine,
      alt: "SYM TerrainX35 rough-terrain forklift",
      description: "4x4 rough-terrain forklift and front loader in one.",
      url: "/terrainx-35-terrainx-35",
    },
    {
      id: "titan35",
      name: "Titan35",
      image:
        "https://symforklift.nyc3.cdn.digitaloceanspaces.com/products/1790685321842-363612811-titan-35-main.webp",
      alt: "SYM Titan35 rough-terrain forklift",
      description: "Enclosed cab, camera monitor and joystick controls.",
      url: "/sym-titan35-titan35",
    },
  ],
};
